/**********************************

  worldpantry-inventory.js   (GOYA -- consolidated fast-ship + live inventory)

  This single file replaces assets/fast-ship.js. It carries the cookie
  helpers, the self-heal, the guarded race-proof auto-trigger (fast
  shipping), AND the live-inventory functions.

  ZIP ACQUISITION: assets/worldpantry-ipzipcode.js (boss's proxy) only. The
  old exposed IPStack access_key + api.ipstack.com call, geoTarget() and the
  leaked `var zipcode` global were already removed and are not present here.

  AUTO-TRIGGER + BUTTON: the shipping form is now a DIV with a
  <button type="button"> (the shared panel), not a <form>. The auto-trigger
  fills the zip input, fires 'input' so the button enables, clicks the
  button, verifies a result stored, and retries if the click raced the
  handler binding. It does NOT call .submit().

  BILINGUAL: nothing language-specific here. The shared logic snippet formats
  the DATE in es-ES on /es pages; this file only stores/reads cookies and
  fetches inventory.

  INVENTORY VALUES (Goya, verbatim): key WP_2026_GOYA,
  /productinventories/goya/, OOS "Usually ships in 1-2 weeks", "In Stock".
  PDP metafields are CAPITALIZED (global.Product_number / Variant_number) --
  read in the PDP snippet, not here.

  LOAD ORDER: requires jQuery (loaded in <head> above this).

***********************************/

var WP_FS = {
  cookies: {
    zip:       'zipcode',
    fsZip:     'FastShip.ZipCode',
    receiveBy: 'FastShip.ReceiveByDateTime',
    orderBy:   'FastShip.OrderByDateTime',
    calcError: 'FastShip.FastShipCalculationError'
  },
  zipInputSelector:  '.zip_input',
  zipButtonSelector: '.zip_button'
};

/**********************************
  Cookie functions
***********************************/
function setSessionCookie(name, value) {
  document.cookie = name + "=" + value + "; path=/";
}

function getSessionCookie(name) {
  var nameKey = name + "=";
  var cDecoded = decodeURIComponent(document.cookie);
  var cArr = cDecoded.split("; ");
  var res;
  cArr.forEach(function (val) {
    if (val.indexOf(nameKey) === 0) res = val.substring(nameKey.length);
  });
  return res;
}

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value != null ? value : "") + expires + "; path=/";
}

function isValidZip(str) {
  return /^\d{5}(-\d{4})?$/.test(str || "");
}

/**********************************
  Self-heal: clear a stuck error cookie, legacy NON-ISO date strings
  ("11 de agosto" etc.), and a stale PAST receive-by date from a previous
  visit, so the auto-trigger refetches a fresh date.
***********************************/
(function selfHealFastShipCookies() {
  var err = getSessionCookie(WP_FS.cookies.calcError);
  if (err) {
    var zip = getSessionCookie(WP_FS.cookies.fsZip);
    if (err === "No Error" || !isValidZip(zip)) deleteCookie(WP_FS.cookies.calcError);
  }

  var receiveBy = getSessionCookie(WP_FS.cookies.receiveBy);
  var orderBy = getSessionCookie(WP_FS.cookies.orderBy);

  // Raw ISO contains "T"; a stored localized string ("11 de agosto") does
  // not -> clear it.
  if ((receiveBy && receiveBy.indexOf("T") === -1) ||
      (orderBy && orderBy.indexOf("T") === -1)) {
    deleteCookie(WP_FS.cookies.receiveBy);
    deleteCookie(WP_FS.cookies.orderBy);
    return;
  }

  // Stale PAST date from a previous visit -> clear (day granularity).
  if (receiveBy) {
    var rd = new Date(receiveBy);
    if (!isNaN(rd)) {
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var day = new Date(rd.getFullYear(), rd.getMonth(), rd.getDate());
      if (day.getTime() < today.getTime()) {
        deleteCookie(WP_FS.cookies.receiveBy);
        deleteCookie(WP_FS.cookies.orderBy);
      }
    }
  }
})();

/**********************************
  Auto-trigger (race-proof). Guarded to run once even if this file were
  loaded more than once. Waits for jQuery, calls the shared early-paint
  (window.wpFsRestore) if present, then once a VALID zip cookie lands fills
  the input, fires 'input' to enable the button, clicks it, and verifies +
  retries if the click raced the handler binding.
***********************************/
(function wpFsAutoTrigger() {
  if (window.wpFsAutoInit) { return; }
  window.wpFsAutoInit = true;

  var jqWaits = 0;
  function whenReady() {
    if (typeof window.jQuery === 'undefined') {
      if (jqWaits++ < 50) { setTimeout(whenReady, 100); }
      return;
    }
    window.jQuery(function ($) {
      if (typeof window.wpFsRestore === 'function') {
        try { window.wpFsRestore(); } catch (e) {}
      }

      if (getSessionCookie(WP_FS.cookies.fsZip) && getSessionCookie(WP_FS.cookies.receiveBy)) {
        console.log("FastShip data already exists, skipping auto lookup");
        return;
      }

      var zipPollTicks = 0;
      var clickTries = 0;
      var clickMax = 10;

      function resultStored() {
        return !!getSessionCookie(WP_FS.cookies.receiveBy);
      }

      function fireAndVerify(zip) {
        if (resultStored()) return;
        console.log("fast geo zip " + zip + (clickTries ? " (retry " + clickTries + ")" : ""));
        // Fill + fire 'input' so the panel button (disabled until 5 chars)
        // enables, otherwise the click hits a disabled button and no-ops.
        $(WP_FS.zipInputSelector).val(zip).trigger('input');
        var $btn = $(WP_FS.zipButtonSelector).first();
        if ($btn.length) $btn.trigger('click');
        clickTries++;
        if (clickTries < clickMax) {
          setTimeout(function () { if (!resultStored()) fireAndVerify(zip); }, 300);
        }
      }

      function waitForZip() {
        var zip = getCookie(WP_FS.cookies.zip);
        if (isValidZip(zip)) { fireAndVerify(zip); return; }
        if (zipPollTicks++ < 40) { setTimeout(waitForZip, 250); }
        else { console.log("no valid zipcode after waiting - manual entry only"); }
      }

      waitForZip();
    });
  }
  whenReady();
})();

/**********************************

  Live Inventory functions  (Goya values, verbatim)

***********************************/

var WP_INV = {
  endpointKey: 'WP_2026_GOYA',
  inventoryUrlSingle: 'https://shop.worldpantry.com/productinventories/goya/productinventory.aspx',
  inventoryUrlBatch:  'https://shop.worldpantry.com/productinventories/goya/productinventories.aspx',
  outOfStockDisplay: 'Usually ships in 1-2 weeks',
  inStockDisplay:    'In Stock'
};

function getProductInventoryDisplay(zip, productId, variantId, setProductInventoryStatus) {
  var postproductinventory = jQuery.post(WP_INV.inventoryUrlSingle, {
    zip: zip, key: WP_INV.endpointKey, productid: productId, variantid: variantId
  });
  postproductinventory.done(function (data) {
    if (data) {
      if (data.Status == "OutOfStock" || data.Status == "AlwaysSell") {
        data.StatusDisplay = WP_INV.outOfStockDisplay;
      } else {
        data.StatusDisplay = WP_INV.inStockDisplay;
      }
      setProductInventoryStatus(data);
    }
  });
}

function getProductNumbers() {
  var productNumbers;
  jQuery.ajax({ type: "GET", url: "/cart?view=wp-productnumbers", async: false })
    .done(function (response) { productNumbers = JSON.parse(response); });
  return productNumbers;
}

/* Loop items and POST to the SINGLE productinventory.aspx per variant,
   assembling the array shape the callers expect (.ProductId/.VariantId/.Status).
   async:false because callers use the result immediately; each record is
   stamped with the sent ids so the matcher works if the response omits them. */
function getProductInventories(productNumbers) {
  var productInventories = [];
  var zip = getCookie('zipcode');
  for (var i = 0; i < productNumbers.length; i++) {
    var productId = productNumbers[i].productNumber;
    var variantId = productNumbers[i].variantNumber;
    jQuery.ajax({
      type: "POST",
      url: WP_INV.inventoryUrlSingle,
      data: { zip: zip, key: WP_INV.endpointKey, productid: productId, variantid: variantId },
      async: false
    }).done(function (data) {
      if (data) {
        if (data.ProductId == null) data.ProductId = productId;
        if (data.VariantId == null) data.VariantId = variantId;
        productInventories.push(data);
      }
    });
  }
  return productInventories;
}

function showProductInventoryCartStatusDisplay(productInventories) {
  var show = false;
  if (productInventories) {
    for (var i = 0; i < productInventories.length; i++) {
      if (productInventories[i].Status == "OutOfStock" || productInventories[i].Status == "AlwaysSell") {
        show = true; break;
      }
    }
  }
  return show;
}

/* Guarded against a record with a missing id (.toUpperCase() on undefined). */
function getProductInventory(id, productNumbers, productInventories) {
  for (var n = 0; n < productNumbers.length; n++) {
    if (productNumbers[n].id != id) continue;
    var productNumber = productNumbers[n].productNumber;
    var variantNumber = productNumbers[n].variantNumber;
    for (var i = 0; i < productInventories.length; i++) {
      if (
        productInventories[i].ProductId &&
        productInventories[i].VariantId &&
        productInventories[i].ProductId.toUpperCase() === productNumber.toUpperCase() &&
        productInventories[i].VariantId.toUpperCase() === variantNumber.toUpperCase()
      ) {
        var inv = productInventories[i];
        inv.StatusDisplay =
          (inv.Status === "OutOfStock" || inv.Status === "AlwaysSell")
            ? WP_INV.outOfStockDisplay
            : WP_INV.inStockDisplay;
        return inv;
      }
    }
    return null;
  }
  return null;
}
